import React from "react"
import HorizontalField, {optionalHorizontalField} from "../HorizontalField/HorizontalField"
import {InformationHiding, phonePreview, emailPreview} from "../InformationHiding/InformationHiding"

interface ContactBusinessProductApplicationProps {
	contact: {
		fullName: {first: string; last: string}
		phone?: {countryCode: string; number: string}
		email?: string
		title?: string
	}
	defaultInformationHidingState: boolean
}

export default function ContactBusinessProductApplication({
	contact,
	defaultInformationHidingState,
}: ContactBusinessProductApplicationProps) {
	return (
		<div className="card">
			<div className="card-header">
				<p className="card-header-title">Contact</p>
			</div>
			<div className="card-content">
				<HorizontalField label="Name">
					<input
						type="text"
						readOnly
						value={`${contact.fullName.first} ${contact.fullName.last}`}
						className="input is-static"
					/>
				</HorizontalField>
				{contact.phone ? (
					<HorizontalField label="Phone">
						<InformationHiding
							element={(value) => <input type="text" readOnly value={value} className="input is-static" />}
							getValue={() => `+${contact.phone?.countryCode} ${contact.phone?.number}`}
							placeholder={phonePreview(`+${contact.phone?.countryCode} ${contact.phone?.number}`)}
							defaultIsHidden={defaultInformationHidingState}
							isHiddenIconVisible={true}
						/>
					</HorizontalField>
				) : undefined}
				{contact.email ? (
					<HorizontalField label="Email">
						<InformationHiding
							element={(value) => <input type="text" readOnly value={value} className="input is-static" />}
							getValue={() => contact.email || ""}
							placeholder={emailPreview(contact.email)}
							defaultIsHidden={defaultInformationHidingState}
							isHiddenIconVisible={true}
						/>
					</HorizontalField>
				) : undefined}
				{optionalHorizontalField("Title", contact.title)}
			</div>
		</div>
	)
}
